module.exports = __webpack_public_path__ + "static/media/intel.b2c85efa.png";